// removed by extract-text-webpack-plugin
module.exports = {"root":"user--root--2wLkdYN3","vertical":"user--vertical--1S6SFp2m","horizontal":"user--horizontal--1unTayhX","organization":"user--organization--1ZK-cYMX"};


//////////////////
// WEBPACK FOOTER
// ./components/header/user/styles.css
// module id = ./components/header/user/styles.css
// module chunks = 0